import { NgModule, NO_ERRORS_SCHEMA }   from '@angular/core';
import { BrowserModule }                from '@angular/platform-browser';
import { RouterModule }                 from '@angular/router';
import { InfinityItemModule }           from 'src/infinity-ui';
import { AppComponent }                 from './app.component';

@NgModule({
    imports: [
        BrowserModule,
        RouterModule.forRoot([{ path: "**", component: AppComponent }], { relativeLinkResolution: 'legacy' }),
        InfinityItemModule
    ],
    declarations: [ AppComponent ],
    providers: [],
    schemas: [ NO_ERRORS_SCHEMA ],
    bootstrap: [ AppComponent ]
})
export class AppModule { }
